import {
  ButtonV3,
  GridItem,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';

import CareersTextAnimation from './CareersTextAnimation';

const CareersIntro = (): JSX.Element => {
  const t = useTranslations();

  return (
    <section data-cy="careers-intro">
      <LayoutGrid>
        <GridItem
          colEnd={{ sm: 'main', lg: 6 }}
          colStart={{ sm: 'main' }}
          rowStart={{ lg: 1 }}
          className="pb-2 text-blue-200"
        >
          <TypographyV3 Element="h1" variant="base" color="inherit">
            {t('careers_at_oura')}
          </TypographyV3>
        </GridItem>
        <CareersTextAnimation
          className={cx(
            'col-main row-start-2 mb-8',
            'lg:col-start-11 lg:col-end-15 lg:row-start-1',
          )}
          duration={1000}
          Element="h2"
          endText="Hello"
          startText="Hei"
          variant="h1"
          weight="light"
        />
      </LayoutGrid>
      <LayoutGrid className="md:mt-12 lg:mt-16" rowGap={64}>
        <GridItem
          className="lg:flex lg:items-center"
          colEnd={{ sm: 'main' }}
          colStart={{ sm: 4, md: 6, lg: 15 }}
          rowStart={{ lg: 1 }}
        >
          <div>
            <TypographyV3>{t('how_oura_was_founded')}</TypographyV3>
            <div className="mt-8">
              <ButtonV3 href="#open-positions" variant="secondary-dark">
                {t('see_open_positions')}
              </ButtonV3>
            </div>
          </div>
        </GridItem>
        <GridItem
          className="relative aspect-[3/5] py-72 md:aspect-auto"
          colEnd={{ sm: 'main', lg: 13 }}
          colStart={{ sm: 'full', lg: 'main' }}
          rowStart={{ lg: 1 }}
        >
          <ArtDirectionImage
            fill
            sizes="(max-width: 767px) 390px, 566px"
            alt="career_intro_hero_alt"
            className="object-cover"
            srcSet={[
              {
                src: 'careers/mobile_hero-img',
                media: '(max-width: 767px)',
              },
              {
                src: 'careers/desktop_hero-img',
                media: '(min-width: 768px)',
              },
            ]}
          />
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default CareersIntro;
